import { NgModule } from '@angular/core';
import { SessionExpireDialogComponent } from './session-expire-dialog.component';
// import { BaseUiModule } from '@biz-ui/base-ui.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SessionExpireDialogComponent],
  imports: [
    // BaseUiModule,
    CommonModule,
    MatDialogModule,
    MatIconModule,
  ],
})
export class SessionExpireDialogModule {}
